import { Div } from "@hopper-ui/components";
import { PageLoader } from "@sg-protect/components";
import { type PropsWithChildren, Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router";
import { useShellTranslation } from "./i18n/i18next.ts";

export function RootLayout({ children = <Outlet /> }: PropsWithChildren) {
    const { t } = useShellTranslation();

    return (
        <>
            <ScrollRestoration
                getKey={location => {
                    return location.pathname;
                }}
            />
            <Div display="flex" flexDirection="column" flex="1 0 auto">
                <Suspense fallback={<PageLoader aria-label={t("Loaders.loadingPage")} />}>{children}</Suspense>
            </Div>
        </>
    );
}
